import axios from "@/api/axiosInstance";

export function fetchTransactions(pageNumber) {
  return axios.get(`/api/v1/transactions/userTransactions?page=${pageNumber}`);
}

export function depositFunds(payload) {
  return axios.post(`/api/v1/transactions/deposit`, payload);
}

export function withdrawFunds(payload) {
  return axios.post(`/api/v1/transactions/withdraw`, payload);
}

export function flexiPay(payload) {
  return axios.post(`/api/v1/transactions/flexiText`, payload);
}

export function flexiQuick(payload) {
  return axios.post(`/api/v1/transactions/flexiQuick`, payload);
}

export function quickFlexi(payload) {
  return axios.post(`/api/v1/transactions/quickFlexi`, payload);
}

export function shareFlexi(payload) {
  return axios.post(`/api/v1/transactions/shareFlexi`, payload);
}
